import * as React from 'react';
import { useDocumentTitle } from '@mantine/hooks';
import { useState } from 'react';

type ContentLayoutProps = {
  children: React.ReactNode;
  titleProp: string;
};

function buildDocumentTitle(title: string) {
  return "StudioCast | " + title;
}

export const ContentLayout = ({ children, titleProp }: ContentLayoutProps) => {
  const [title] = useState(buildDocumentTitle(titleProp));
  useDocumentTitle(title);

  return (
    <div className="py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <h1 className="text-2xl font-semibold text-gray-900">{titleProp}</h1>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">{children}</div>
    </div>
  );
};
